export enum ActiveStatus {
    Active = 0,
    DeactivatedByOrganization = 1,
    DeactivatedByDealer = 2,
    DeactivatedByAdmin = 3
}
